import { createSlice } from '@reduxjs/toolkit';

// utils
// @types
import { Mail, MailLabel } from '../../@types/mail';
//
import APIMAIL from 'src/api/mail/apimail';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

function objFromArray(array: any[], key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

type MailState = {
  isLoading: boolean;
  error: Error | string | null;
  mails: {
    byId: Record<string, Mail>;
    allIds: string[];
  };
  labels: MailLabel[];
};

const initialState: MailState = {
  isLoading: false,
  error: null,
  mails: { byId: {}, allIds: [] },
  labels: [],
};

const slice = createSlice({
  name: 'mail',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LABELS
    getLabelsSuccess(state, action) {
      state.isLoading = false;
      state.labels = action.payload;
    },

    // GET MAILS
    getMailsSuccess(state, action) {
      const mails = action.payload;

      state.isLoading = false;
      state.mails.byId = objFromArray(mails);
      state.mails.allIds = Object.keys(state.mails.byId);
    },

    // GET MAIL
    getMailSuccess(state, action) {
      const mail = action.payload;

      state.mails.byId[mail.id] = mail;
      if (!state.mails.allIds.includes(mail.id)) {
        state.mails.allIds.push(mail.id);
      }
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getLabels() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = [
        {
          id: 'inbox',
          type: 'system',
          name: 'Inbox',
          unreadCount: 0,
          color: undefined,
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        {
          id: 'sent',
          type: 'system',
          name: 'Sent',
          unreadCount: 0,
          color: undefined,
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        // {
        //   id: "public",
        //   type: "system",
        //   name: "Public",
        //   unreadCount: 0,
        //   color: '#0066ff'
        // },
        {
          id: 'coordinator',
          type: 'system',
          name: 'Coordinator',
          unreadCount: 0,
          color: '#0066ff',
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        {
          id: 'client',
          type: 'system',
          name: 'Client',
          unreadCount: 0,
          color: '#ff6600',
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        {
          id: 'country',
          type: 'system',
          name: 'Resource',
          unreadCount: 0,
          color: '#ffcc00',
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
      ];
      dispatch(slice.actions.getLabelsSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMails(params: Record<string, string>, assignmentId: string) {
  return async () => {
    var inboxCount = 0;
    var sentCount = 0;
    dispatch(slice.actions.startLoading());
    try {
      const apimail = new APIMAIL();
      apimail.init();
      let respUser = await apimail.getMailbox(assignmentId, params.systemLabel);
      //console.log(respUser);
      let respMail = respUser.mailData;
      respMail.sort(function (a: any, b: any) {
        var dateA = new Date(a.createdAt),
          dateB = new Date(b.createdAt);
        return dateB.getTime() - dateA.getTime();
      });

      if(respUser.labelData.inbox > 0){
        inboxCount = respUser.labelData.inbox;
      }

      if(respUser.labelData.sent > 0){
        sentCount = respUser.labelData.sent
      }

      dispatch(slice.actions.getMailsSuccess(respMail));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }

    const labelsResp = [
        {
          id: 'inbox',
          type: 'system',
          name: 'Inbox',
          unreadCount: inboxCount,
          color: undefined,
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        {
          id: 'sent',
          type: 'system',
          name: 'Sent',
          unreadCount: sentCount,
          color: undefined,
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        // {
        //   id: "public",
        //   type: "system",
        //   name: "Public",
        //   unreadCount: 0,
        //   color: '#0066ff'
        // },
        {
          id: 'coordinator',
          type: 'system',
          name: 'Coordinator',
          unreadCount: 0,
          color: '#0066ff',
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        {
          id: 'client',
          type: 'system',
          name: 'Client',
          unreadCount: 0,
          color: '#ff6600',
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
        {
          id: 'country',
          type: 'system',
          name: 'Resource',
          unreadCount: 0,
          color: '#ffcc00',
          //users: ['Coordinator','Limited Access Coordinator','Company User','Reviewer']
        },
      ];
      //console.log(labelsResp);
      dispatch(slice.actions.getLabelsSuccess(labelsResp));
  };
}

// ----------------------------------------------------------------------

export function getMail(mailId: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const apimail = new APIMAIL();
      apimail.init();
      //let response = await apimail.getMailDetails(mailId);
      dispatch(slice.actions.getMailSuccess(undefined));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
